// App-shell 2026-09-14 — who reads the two app-wide lists, and the poll's freshness stamp.
// Stage 0 audit: docs/audit/2026-09-14-portal-cost-discovery.md §2.2 (the consumer table).
import { supabase } from "../supabase";

// The FULL developments list (DEV_LIST_SELECT, every page): only the Developments portal — its
// list / grid / by designer and the board's client filters (Conv #144). Nothing else loads it:
// the header bell reads useDeadlineDevs, the Catalog and the Overview read useDevLinksSlim,
// Favorites read their ids (useFavoriteRows), Global search asks the server (globalSearchServer).
export const TABS_READING_ALL_DEVS = new Set(["developments", "dashboard"]);

// The slim items read (useItemsStatsSlim → allItemsStats — every item, ten fields, never images):
// the Catalog stats strip and brand / created-by lists, the Originals Overview, Settings' brand
// manager, the brand auto-sync. Developments reads its linked items by id (useLinkedItems), its
// pickers and Global search ask the server, Favorites and the completion card fetch by id.
export const TABS_READING_ALL_ITEMS = new Set(["catalog", "overview", "settings"]);

// The link facts of every active development (useDevLinksSlim): the Catalog's linkedDevsMap
// (cards' linked counts, the DA/DO/DS reverse search) and the Overview's linkage / stage counts.
export const TABS_READING_LINKS = new Set(["catalog", "overview"]);

// The 60 s poll's freshness check — no rows: a HEAD count and the newest created_at. `items`
// has no updated_at (column or key, checked 2026-09-14), so an UPDATE reaches a client through
// realtime; this guards inserts, deletes and a dropped websocket. Aggregates never go through
// PostgREST (PGRST123) — "max" is order desc + limit 1.
export async function readItemsStamp() {
  const [{ count }, { data: newest }] = await Promise.all([
    supabase.from("items").select("id", { count: "exact", head: true }),
    supabase.from("items").select("created_at").order("created_at", { ascending: false }).limit(1),
  ]);
  return { liveCount: count, stamp: `${count ?? "?"}|${newest?.[0]?.created_at || ""}` };
}
